import { Button, ISearchFilterRef } from '@/components';
import { useCreateListSubmit } from '@/hooks';
import { memo, ReactNode, RefObject, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const HeaderList = ({
	title,
	description,
	count = undefined,
	onClickCreate,
	createBtnHidden,
	actions,
	toCreatePathName,
	searchFilterRef,
	callbackAfterClosePopup,
}: {
	title: string;
	description?: string;
	count?: number;
	onClickCreate?: () => void;
	createBtnHidden?: boolean;
	actions?: ReactNode;
	toCreatePathName?: string;
	searchFilterRef?: RefObject<ISearchFilterRef>;
	callbackAfterClosePopup?: (data?: any) => void;
}) => {
	const { t } = useTranslation('common');

	const { onCreateSubmit } = useCreateListSubmit({
		toCreatePathName,
		searchFilterRef,
		callbackAfterClosePopup,
	});

	const _onClick = useCallback(() => {
		onClickCreate?.();

		onCreateSubmit?.();
	}, [onClickCreate, onCreateSubmit]);

	return (
		<div className="row-between mb-5 container-header-list bg-white h-[60px] ml-[-36px] mr-[-16px] 2xl:mx-[-36px] px-9 border-b border-gray9 shadow-headerList sticky z-[11] top-0 left-0 right-0">
			<div>
				<h2 className="font-semibold text-xl text-font3 leading-6">
					{title}
					{count !== undefined && count !== null && (
						<>
							{' '}
							(<span className="text-blue3">{count}</span>)
						</>
					)}
				</h2>
				{description && (
					<p className="font-normal text-xs text-font8 leading-[14px] mt-1 line-clamp-1">
						{description}
					</p>
				)}
			</div>
			<div className="row gap-x-2">
				{actions}
				{!createBtnHidden && (
					<Button type="primary" isMainBtn onClick={_onClick}>
						{t('register')}
					</Button>
				)}
			</div>
		</div>
	);
};

export default memo(HeaderList);
